const lowOf = (bar) => bar.low;
const highOf = (bar) => bar.high;
const closeOf = (bar) => bar.close;

const rangeOf = (bars, first, last, readLow, readHigh) => {
  if (first > last) return null;

  let min = Infinity;
  let max = -Infinity;

  for (let index = first; index <= last; index += 1) {
    const bar = bars[index];

    min = Math.min(min, readLow(bar));
    max = Math.max(max, readHigh(bar));
  }

  return { min, max };
};

/**
 * Lowest low and highest high of bars first..last.
 *
 * @returns {{ min: number, max: number } | null} null when the range is empty
 */
export const highLowRange = (bars, first, last) => rangeOf(bars, first, last, lowOf, highOf);

/**
 * Lowest and highest close of bars first..last (the Line chart).
 *
 * @returns {{ min: number, max: number } | null} null when the range is empty
 */
export const closeRange = (bars, first, last) => rangeOf(bars, first, last, closeOf, closeOf);

// The first bar wins a tie, as in the TradingView labels
const extremesOf = (bars, first, last, readLow, readHigh) => {
  if (first > last) return null;

  let highIndex = first;
  let lowIndex = first;

  for (let index = first + 1; index <= last; index += 1) {
    if (readHigh(bars[index]) > readHigh(bars[highIndex])) highIndex = index;
    if (readLow(bars[index]) < readLow(bars[lowIndex])) lowIndex = index;
  }

  return {
    high: { index: highIndex, price: readHigh(bars[highIndex]) },
    low: { index: lowIndex, price: readLow(bars[lowIndex]) },
  };
};

/**
 * Bars with the highest high and the lowest low among bars first..last.
 *
 * @returns {{ high: { index: number, price: number }, low: { index: number, price: number } } | null}
 *   null when the range is empty
 */
export const highLowExtremes = (bars, first, last) => extremesOf(bars, first, last, lowOf, highOf);

/**
 * Bars with the highest and the lowest close among bars first..last (the Line chart).
 *
 * @returns {{ high: { index: number, price: number }, low: { index: number, price: number } } | null}
 *   null when the range is empty
 */
export const closeExtremes = (bars, first, last) => extremesOf(bars, first, last, closeOf, closeOf);
